import React, { useState } from "react";
import { Switch, Route } from "react-router-dom";
import { ListProvider } from "context/List/Context";
import produitDataFetcher from "dataProvider/Produit";
import ListComponent from "./List";
import View from "./View";

const ProduitRouter: React.FC = () => {
    const [toNext, setToNext] = useState<boolean>(false);
    const [toBack, setToBack] = useState<boolean>(false);
    return (
        <ListProvider
            dataFetcher={produitDataFetcher.all}
            defaultFetcherParams={{ order: "libel", direction: "asc" }}
            defaultFetch={false}
        >
            <Switch>
                <Route
                    path={`/produit/:id`}
                    component={(props: any) => (
                        <View
                            key={props.match.id}
                            toNext={toNext}
                            setToNext={setToNext}
                            toBack={toBack}
                            setToBack={setToBack}
                        />
                    )}
                />
                <Route component={ListComponent} />
            </Switch>
        </ListProvider>
    );
};

export default ProduitRouter;
